import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import AddToStudiesModal from 'studies/studyable/AddToStudiesModal';
import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import runModal from 'ui-library/runModal';

export interface AddToStudiesButtonProps {
  itemIds: Array<string>;
  buttonStyle?: ButtonStyle;
  className?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  showText?: boolean;
  tooltipTitleWhenDisabled?: string;
}

export default function AddToStudiesButton({
  itemIds,
  buttonStyle = ButtonStyle.TERTIARY_BLUE,
  className,
  disabled,
  fullWidth,
  showText,
  tooltipTitleWhenDisabled,
}: AddToStudiesButtonProps): JSX.Element {
  return (
    <Tooltip
      title={disabled ? tooltipTitleWhenDisabled : 'Add to studies'}
      disabled={disabled && tooltipTitleWhenDisabled == null}
    >
      <Button
        buttonStyle={buttonStyle}
        className={className}
        disabled={disabled}
        fullWidth={fullWidth}
        icon={ModelTypeConstants.STUDY}
        onClick={() => {
          runModal(AddToStudiesModal, {itemIds});
        }}
        size={ButtonSize.SMALL}
        text={showText ? 'Add to studies' : null}
      />
    </Tooltip>
  );
}
